<div class="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md lg:w-full space-y-8">
    <div class="flex justify-between p-2">
      <div>
        <h2 class="text-center text-3xl font-semibold text-gray-900">
          Add Guest Users
        </h2>
      </div>
      <div>
        <button
          class="text-center text-md bg-[#E31C79] text-sm text-white hover:bg-rose-700 focus:outline-none font-normal px-4 py-2 rounded-md"
          (click)="openDialog()"
        >
          Add User
        </button>
      </div>
    </div>
    <div *ngIf="users.length > 0"
      class="max-w-md mx-auto mt-8 bg-white shadow-md rounded px-2 md:px-8 pt-6 pb-8 mb-4"
    >
      <table class="border-collapse w-full">
        <thead class="">
          <tr class="bg-green-600 text-white">
            <th class="px-2 py-1 text-left font-medium">User</th>
            <th class="px-2 py-1 text-right font-medium">Active</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let user of users; let i = index">
            <tr class="border-t">
              <td class="p-2">
                <div class="flex items-center gap-1">
                  <div
                    class="h-10 w-10 flex items-center justify-center bg-black text-white rounded-full"
                  >
                    <span class="text-lg font-semibold">{{user.profile}}</span>
                  </div>
                  <div>
                    <p class="font-medium  ">{{ user.firstName }}</p>
                    <p class="text-gray-600">{{ user.email }}</p>
                  </div>
                </div>
              </td>
              <td class="p-4 text-right">
                <div
                  class="bg-gray-300 rounded-full text-white cursor-pointer"
                  [ngClass]="{
                    'bg-rose-400':
                      user.isActive
                  }"
                  (click)="swicgToggle(user.id, i)"
                >
                  <div
                    class="w-5 h-5 flex items-center rounded-full shadow-md transform duration-300 ease-in-out bg-white"
                    [ngClass]="{
                      'translate-x-5 lg:translate-x-6': user.isActive
                    }"
                  ></div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #userModal let-modal>
  <div class="flex justify-end p-4">
    <div class="flex items-end">
      <div
        (click)="closeDialog()"
        class="h-10 w-10 flex items-center justify-center bg-black text-white rounded-full"
      >
        <button class="text-lg	text-white rounded-r px-3">X</button>
      </div>
    </div>
  </div>
  <div class="flex items-center justify-center">
    <form
      class="w-full md:w-9/12 bg-white shadow-lg rounded px-8 pt-6 pb-8 mb-4"
      [formGroup]="signUpForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="firstName"
        >
          First Name
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="firstName"
          type="text"
          formControlName="firstName"
          placeholder="First Name"
        />
        @if ((f.firstName.touched || submitted) &&
        f.firstName.hasError('required')) {
        <span class="text-xs text-red-400 m-0 p-0"
          >First Name is <strong>required</strong></span
        >
        }
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="lastName"
        >
          Last Name
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="lastName"
          type="text"
          formControlName="lastName"
          placeholder="Last Name"
        />
        @if ((f.lastName.touched || submitted) &&
        f.lastName.hasError('required')) {
        <span class="text-xs text-red-400 m-0 p-0"
          >Last Name is <strong>required</strong></span
        >
        }
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
          Email
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="email"
          type="email"
          placeholder="Email"
          formControlName="email"
        />
        @if ((f.email.touched || submitted) && f.email.hasError('required')) {
        <span class="text-xs text-red-400 m-0 p-0"
          >Email is <strong>required</strong></span
        >
        }
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="password"
        >
          Password
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="password"
          type="password"
          placeholder="Password"
          formControlName="password"
        />
        @if ((f.password.touched || submitted) &&
        f.password.hasError('required')) {
        <span class="text-xs text-red-400 m-0 p-0"
          >Password is <strong>required</strong></span
        >
        }
      </div>
      <div>
        <button
          type="submit"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm  rounded-md text-white bg-[#E31C79] hover:bg-rose-700 focus:outline-none font-normal focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <span class="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg
              class="h-5 w-5 text-rose-500 group-hover:text-rose-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M10 12a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              ></path>
              <path
                d="M4 8V6a4 4 0 014-4h4a4 4 0 014 4v2h1a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h1zm4-2V6a2 2 0 00-2-2h4a2 2 0 00-2 2v2h2a1 1 0 011 1v5H7v-5a1 1 0 011-1h2z"
              ></path>
            </svg>
          </span>
          Add User
        </button>
      </div>
    </form>
  </div>
</ng-template>
